import { Modal, SubmitButton } from "@xola/ui-kit";
import { FormField, InputField, requiredString } from "common";
import React from "react";
import { Report } from "types";
import { object } from "yup";
import { SecondaryButton } from "../../Common/SecondaryButton";
import { XolaFormik } from "../../Common/XolaFormik";

interface SaveReportModalProps {
    isOpen: boolean;
    isLoading: boolean;
    report: Report;
    onSubmit: (report: Report) => void;
    onClose: () => void;
    isScheduledReport: boolean;
}

export const SaveReportModal = ({
    isOpen,
    isLoading,
    report,
    onSubmit,
    onClose,
    isScheduledReport,
}: SaveReportModalProps) => {
    return (
        <XolaFormik initialValues={report} validationSchema={validationSchema} onSubmit={onSubmit}>
            {({ handleSubmit }) => (
                <Modal isOpen={isOpen} onClose={onClose}>
                    <Modal.Header>Save Report</Modal.Header>

                    <Modal.Body>
                        <FormField name="title" label="Title">
                            <InputField />
                        </FormField>
                    </Modal.Body>

                    {isScheduledReport ? (
                        <div className="bg-warning-lighter p-2">
                            <span className="text-base">This report needs to be saved before you can schedule it.</span>
                        </div>
                    ) : null}

                    <Modal.Footer>
                        <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
                        <SubmitButton isLoading={isLoading} onClick={handleSubmit}>
                            Save
                        </SubmitButton>
                    </Modal.Footer>
                </Modal>
            )}
        </XolaFormik>
    );
};

const validationSchema = object({
    title: requiredString(),
});
